var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/download",
    clipPath: "url(#clip0_4458_5249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C8.37297 0 8.68037 0.280757 8.72238 0.642457L8.72727 0.727273L8.72704 10.6269L11.1151 8.24296C11.3993 7.95911 11.8597 7.95939 12.1436 8.24359C12.4056 8.50592 12.4255 8.91846 12.2035 9.20363L12.143 9.27211L8.55033 12.8604C8.26005 13.1503 7.80256 13.1707 7.48795 12.9211L7.41803 12.8587L3.84717 9.27055C3.56384 8.98584 3.56496 8.52536 3.84966 8.24203C4.11246 7.98049 4.52504 7.96133 4.80981 8.18385L4.87818 8.24452L7.27249 10.6502L7.27273 0.727273C7.27273 0.325611 7.59834 0 8 0ZM0 15.2667C0 14.865 0.325611 14.5394 0.727273 14.5394H15.2727C15.6744 14.5394 16 14.865 16 15.2667C16 15.6684 15.6744 15.994 15.2727 15.994H0.727273C0.325611 15.994 0 15.6684 0 15.2667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4458_5249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.b2972513a67932762b5c3da43796400a.svg";
export { ForwardRef as ReactComponent };